import * as React from 'react';
import styled from 'styled-components';
import MuiRadioGroup, { RadioGroupProps as MuiRadioGroupProps } from '@material-ui/core/RadioGroup';

const StyledRadioGroup = styled(MuiRadioGroup)``;

export type DSRadioGroupProps = MuiRadioGroupProps;
export const DSRadioGroup: React.FC<DSRadioGroupProps> = StyledRadioGroup;
DSRadioGroup.displayName = 'DSRadioGroup';
